export default __webpack_public_path__ + "static/media/nether_mint.a31dba6a.png";